import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewProduct from './AddNewProduct';
import {
    faTrashAlt,
    faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function ProductFormButton({
    id,
    LoadData,
    categoryList,
    createdBy
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            {/* <Button
                color="primary"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            > */}
            {createdBy && (createdBy === 'Farehourbor' || createdBy === 'Rezdy' || createdBy === 'Ways') ?
                <i
                    style={{ cursor: 'pointer' }}
                    onClick={() => setIsUpdating(!isUpdating)}
                    className="icon-open"
                    title="View"
                >
                    <svg
                        fill="none"
                        height="20"
                        viewBox="0 0 24 24"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14"
                            stroke="#90caf9"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </svg>
                </i> :
                <div>
                    <FontAwesomeIcon style={{ width: '16px', height: '16px' }}
                        icon={faEdit}
                        color="#90caf9"
                        cursor="pointer"
                        title="Edit"
                        onClick={() => setIsUpdating(!isUpdating)}
                    />
                </div>
            }
            {/* </Button> */}
            {isUpdating && (
                <AddNewProduct
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit Product"
                    visible={isUpdating}
                    LoadData={LoadData}
                    categoryList={categoryList}
                />
            )}
        </div>
    );
}

